<template>
  <div class="profile-score-wrap" v-show="profile_data.score">
    <div class="profile-score" :class="profile_data.score >= 80 ? 'excellent' : profile_data.score >= 60 ? 'good' : profile_data.score >= 40 ? 'average' : 'low'">
      <div class="profile-score-title">
        <!-- <span class="profile-score-beta">beta</span> -->
        SCORE
        <el-tooltip placement="top-end">
          <div slot="content" v-html="scoreTooltip"></div>
          <font-awesome-icon :icon="['fas', 'question-circle']" style="margin-left: 5px;" />
        </el-tooltip>
      </div>
      <div>{{ profile_data.score }}</div>
      <div class="profile-score-100">of 100</div>
    </div>
    <div class="profile-score-bottom">
      {{ profile_data.score >= 80 ? "Excellent" : profile_data.score >= 60 ? "Good" : profile_data.score >= 40 ? "Average" : profile_data.score >= 20 ? "Low" : "Very Low" }}
    </div>
  </div>
</template>
<script>
import { getScoreDetailTooltip } from "../../const/scoreDescription";

export default {
  props: {
    profile_data: Object,
    sns_type: {
      type: String,
      default: "instagram",
    },
  },
  computed: {
    scoreTooltip() {
      return getScoreDetailTooltip(this.sns_type);
    },
  },
}
</script>